module.exports = __webpack_public_path__ + "img/knee.6f6762df.jpg";